import { render, staticRenderFns } from "./Eu.vue?vue&type=template&id=f85660c0"
import script from "./Eu.vue?vue&type=script&lang=js"
export * from "./Eu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports